import { UserDto } from '@act/shared/data-transfer-objects';

export const checkBirthday = (dateOfBirth: string) => {
  const today = new Date();
  const birthDate = new Date(dateOfBirth);
  const currentMonth = today.getMonth();
  const currentDay = today.getDate();
  const birthMonth = birthDate.getMonth();
  const birthDay = birthDate.getDate();

  if (currentMonth === birthMonth) {
    const dayDiff = Math.abs(currentDay - birthDay);
    return dayDiff <= 7 ? '🎂' : '';
  }

  // Handle month boundaries
  const daysInMonth = (month: number) => {
    const daysInMonths = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    return daysInMonths[month];
  };

  // Check if months are adjacent
  const isAdjacent =
    currentMonth === birthMonth + 1 ||
    (currentMonth === 0 && birthMonth === 11) ||
    currentMonth === birthMonth - 1 ||
    (currentMonth === 11 && birthMonth === 0);

  if (isAdjacent) {
    let dayDiff;

    if (
      currentMonth === birthMonth + 1 ||
      (currentMonth === 0 && birthMonth === 11)
    ) {
      // Current month is after birth month
      const daysInBirthMonth = daysInMonth(birthMonth);
      dayDiff = daysInBirthMonth - birthDay + currentDay;
    } else {
      // Current month is before birth month
      const daysInCurrentMonth = daysInMonth(currentMonth);
      dayDiff = daysInCurrentMonth - currentDay + birthDay;
    }

    return dayDiff <= 7 ? '🎂' : '';
  }

  return '';
};

export const displayName = (
  member: UserDto,
  options?: { hideLastName?: boolean; hideBirthday?: boolean }
) => {
  if (!member) return 'Unknown';

  const name =
    !options?.hideLastName && member.lastName
      ? `${member.firstName} ${member.lastName}`
      : member.firstName;

  if (options?.hideBirthday) {
    return name;
  }

  const birthday = checkBirthday(member.dateOfBirth);
  return `${name} ${birthday}`;
};
